import React from 'react'
import "./FloatingButton.css"
import Img from "../../assets/images/floating.png"
import { Link } from 'react-router-dom'

const FloatingButton = () => {

    const phoneNumber = "+971503771775";
    const message = "Hello, I need help with your product!";
    const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;


    return (
        <>
            <Link className='floatingButton' to={whatsappLink} target="_blank">
                <img src={Img} alt="" />
            </Link>
        </>
    )
}

export default FloatingButton